module.exports = __webpack_public_path__ + "components/flag/static/square/tf-2d675fbac57ec9acd92bcb01f1087d96.svg";